import {faHeart} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'
import {earnRewardsLink, earnRewardsIconStyle} from './earn-rewards.module.scss'

export function EarnRewards() {
  const {t} = useSafeTranslation()
  return (
    <Link
      size="md"
      style="normal"
      className={earnRewardsLink}
      href={Routes.referralProgram()}
      reactRouter
    >
      <Flex alignItems="center">
        <FontAwesomeIcon icon={faHeart} className={earnRewardsIconStyle} />
        <Text style="subtitle-2" htmlElement="span">
          {t('EARN_REWARDS_NAV_ITEM')}
        </Text>
      </Flex>
    </Link>
  )
}
